import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import CollectionFilterItem from '../CollectionFilterItem/CollectionFilterItem';
import { IconArrowDown } from '../Icons';
import { StyledWrapper, StyledButton, StyledUl } from './CollectionFilterListStyles';

var _ref = React.createElement(IconArrowDown, null);

var CollectionFilterList = function CollectionFilterList(props) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var toggleActive = function toggleActive() {
    setActive(!active);
  };

  // remove Type from Color Type
  var title = props.title.replace(' Type', '');
  var listType = props.useSwatch ? 'swatch' : props.useListItem ? 'list-item' : 'btn';

  return React.createElement(
    StyledWrapper,
    null,
    React.createElement(
      StyledButton,
      { onClick: toggleActive, active: active },
      React.createElement(
        'h6',
        null,
        title
      ),
      _ref
    ),
    React.createElement(
      StyledUl,
      { type: listType, active: active },
      props.filterTags.map(function (tag) {
        return React.createElement(CollectionFilterItem, {
          type: listType,
          useSwatch: props.useSwatch,
          key: tag.title,
          tag: tag,
          handleFilterClick: props.handleFilterClick,
          activeFilters: props.activeFilters,
          useLink: props.useLink
        });
      })
    )
  );
};

CollectionFilterList.propTypes = {
  activeFilters: PropTypes.object.isRequired,
  handleFilterClick: PropTypes.func,
  filterTags: PropTypes.array.isRequired,
  useListItem: PropTypes.bool.isRequired,
  useSwatch: PropTypes.bool.isRequired,
  title: PropTypes.string,
  useLink: PropTypes.bool
};

export default CollectionFilterList;